import React from 'react';
import styled from 'styled-components';
import Loading from './Loading';

interface Props {}

const LoginLoader: React.FC<Props> = () => (
  <LoadingWrapper>
    <Loading />
  </LoadingWrapper>
);

export default LoginLoader;

const LoadingWrapper = styled.div`
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
